// Create Issue page
// Reference: spec.md US1 - leaseholder creates an issue

import { useNavigate } from 'react-router-dom';
import { IssueForm } from '../../components/issues/IssueForm';
import type { Issue } from '@propman/shared';

export function CreateIssuePage() {
  const navigate = useNavigate();

  const handleSuccess = (issue: Issue) => {
    // Navigate to the issue detail or list with success message
    navigate(`/issues?created=${issue.referenceNumber}`);
  };

  const handleCancel = () => {
    navigate('/issues');
  };

  return (
    <div className="max-w-2xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Report an Issue</h1>
        <p className="mt-1 text-sm text-gray-600">
          Fill out the form below to report a maintenance issue or problem
        </p>
      </div>

      {/* Form card */}
      <div className="card p-6">
        <IssueForm onSuccess={handleSuccess} onCancel={handleCancel} />
      </div>

      {/* Help text */}
      <div className="mt-6 bg-blue-50 border border-blue-200 rounded-md p-4">
        <h3 className="text-sm font-medium text-blue-800">Tips for reporting issues</h3>
        <ul className="mt-2 text-sm text-blue-700 list-disc list-inside space-y-1">
          <li>Be as specific as possible about the location</li>
          <li>Describe when the issue started or when you first noticed it</li>
          <li>Include photos if possible to help diagnose the problem</li>
          <li>Note any safety concerns that require urgent attention</li>
        </ul>
      </div>
    </div>
  );
}

export default CreateIssuePage;
